import moment from 'moment-timezone'

/**
 * Shared, locale-configured moment for every calendar module.
 *
 * We register the German locale HERE instead of `import 'moment/locale/de'`:
 * Vite's dev dependency optimizer pre-bundles `moment/locale/de` as its own entry
 * with a second, embedded copy of moment, so that side-effect import registers
 * German on a *different* instance than the one we format dates with — and month
 * and weekday names silently fall back to English. (The production build dedupes
 * moment into one instance, so it only breaks with the dev server.) Defining the
 * locale on this instance gives every calendar a single, German-aware moment.
 */
moment.defineLocale('de', {
  months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
  monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
  weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
  weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
  weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
  week: { dow: 1, doy: 4 }, // weeks start Monday (ISO)
})

const rawLang = (window.php_vars?.lang || document.documentElement.lang || 'en').toLowerCase()
export const lang = rawLang.split('-')[0] === 'de' ? 'de' : 'en'

// Earliest month any calendar may show. The site launches July 2026 and holds no
// events before it, so back-navigation is capped here. This is a FIXED date (not
// "today − N months"): the floor is where the data begins, so it stays put as time
// moves on — from later months you can page back only as far as July 2026.
export const CALENDAR_FLOOR = '2026-07-01'

// defineLocale('de') made German the active locale as a side effect; pin it to
// the actual page language (English is moment's built-in default).
moment.locale(lang)

export default moment
